module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Alerts")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, _vm._l((_vm.alerts), function(item, index) {
    return _c('v-card', {
      key: ("item-" + index),
      staticClass: "info"
    }, [_c('v-list', [_c('v-list-tile', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("alert_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.alertName)
      }
    }, [_vm._v(_vm._s(item))])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.userIsCreator(index)) ? [_c('app-edit-alert-dialog', {
      attrs: {
        "alert": _vm.alert(index)
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteAlert(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "to": '/alerts/' + item.alertId
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    }, [_vm._v("navigate_next")])], 1)], 1)], 1)], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b4c325b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert/Alerts.vue
// module id = 667
// module chunks = 1